import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { GlobalNavigation } from 'site-modules/shared/components/global-navigation-v2/global-navigation';
import { Footer } from 'site-modules/shared/components/footer/footer';
import { StickyBanner } from 'site-modules/shared/components/sticky-banner/sticky-banner';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { SpaLinks } from 'site-modules/shared/components/spa-links/spa-links';
import { ProfileContextAsync } from 'site-modules/shared/components/profile/profile-context-async';
import { ExperimentsPanel } from 'site-modules/shared/components/experiment/panel/experiments-panel';
import { AdsContext } from 'site-modules/shared/components/ads-context/ads-context';
import { VehicleModel } from 'client/data/models/vehicle';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { ClientSideRender } from 'site-modules/shared/components/client-side-render/client-side-render';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { ErrorPageMessage } from 'site-modules/shared/components/error-page-message/error-page-message';
import { PubpixelAd } from 'site-modules/shared/components/pubpixel/pubpixel-ad';
import { getQuery } from 'client/utils/location';
import { SEOHead } from 'site-modules/shared/pages/seo';
import { VisitorModel } from 'client/data/models/visitor';

export class TypePageDecoratorUI extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    isMobile: PropTypes.bool,
    isSubtypeExpansionPage: PropTypes.bool,
  };

  static defaultProps = {
    isMobile: false,
    isSubtypeExpansionPage: false,
  };

  static preload(store) {
    const preloader = new ModelPreloader(store);
    preloader.resolve('makesList', VehicleModel);
    preloader.resolve('rttSegment', VisitorModel);

    return preloader.load();
  }

  render() {
    const query = getQuery(this.props.location);
    const trkParam = query.trk ? { trk: query.trk } : {};
    const isTypePage = /^\/[a-z-]+\/$/.test(this.props.location.pathname);

    return (
      <div className={classnames('edm-page has-global-nav', { desktop: !this.props.isMobile })}>
        <ErrorBoundary>
          <GlobalNavigation showSearchBar isLaurelBg={isTypePage} />
        </ErrorBoundary>
        <SEOHead {...this.props} />
        <FeatureFlag name="testSpa">
          <SpaLinks />
        </FeatureFlag>
        <ErrorBoundary Fallback={ErrorPageMessage}>{this.props.children}</ErrorBoundary>
        <ErrorBoundary>
          <Footer />
        </ErrorBoundary>
        <FeatureFlag name="ads">
          <ErrorBoundary>
            <StickyBanner trkParam={trkParam} />
          </ErrorBoundary>
          <ErrorBoundary>
            <PubpixelAd />
          </ErrorBoundary>
          <ErrorBoundary>
            <AdsContext />
          </ErrorBoundary>
        </FeatureFlag>
        <ClientSideRender>
          <ProfileContextAsync />
          <ExperimentsPanel />
        </ClientSideRender>
      </div>
    );
  }
}

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const TypePageDecorator = connect(mapStateToProps)(TypePageDecoratorUI);
